import React, { useContext, useEffect, useState } from "react";
// import { ISlideInContent } from "ft-shared-components"
import { ISlideInContent } from "./contentTypes";
export type SlideInContent = {
    open: boolean;
    disableClose: boolean;
    toggleDrawer: () => void,
    disableClosingDrawer: (value: boolean) => void,
    content?: ISlideInContent,
    slideInProps?: any,
    handleContent: <T = any> (content: ISlideInContent<T>,
        props?: T
    ) => void
};

const SlideInContext = React.createContext<SlideInContent>({
    open: false,
    disableClose: false,
    toggleDrawer: () => { return },
    disableClosingDrawer: (value: boolean) => { return },
    content: undefined,
    slideInProps: undefined,
    handleContent: () => { return }
});

SlideInContext.displayName = 'SlideInContext';

const useSlideInContext = () => useContext(SlideInContext);

interface IProps {
    children: React.ReactNode
};

interface IProps {
    children: React.ReactNode
};

const SlideInContextProvider = (props: IProps) => {
    const { children } = props;
    const [content, setContent] = useState<ISlideInContent>();
    const [slideInProps, setSlideInProps] = useState();
    const [open, setOpen] = useState(false);
    const [disableClose, setDisableClose] = useState(false);

    const handleContent = (_content: ISlideInContent, props?: any) => {
        setContent(_content)
        setOpen(true)
        setSlideInProps(props)
        return;
    };

    useEffect(() => {
        if (!open && content) {
            setOpen(true);
        };
    }, [content]);

    const toggleDrawer = () => {
        setOpen(prev => !prev)
        return;
    };

    const disableClosingDrawer = (value: boolean) => {
        setDisableClose(value);
        return;
    }

    return (
        <SlideInContext.Provider
            value={{
                open,
                disableClose,
                toggleDrawer,
                disableClosingDrawer,
                handleContent,
                content,
                slideInProps
            }}>
            {children}
        </SlideInContext.Provider>
    );
};

export { useSlideInContext, SlideInContextProvider };
